import { TweenMax } from 'gsap';
import { getGameSize } from '../../../../Config/Levels';
import { gameConfig } from '../../../../index';
import { HudActions, HudEmitter } from '../../../../Managers/Hud/HudEmitter';
import { ITweenable } from '../../ITweenable';
import { ShareButton } from './ShareButton';
import { ShareableMoments } from '../../../../SDK/SDKmessages';
import { Platform } from '../../../../SDK/SDK';

export abstract class ShareableOverlay extends PIXI.Container implements ITweenable {
    public shareButton: ShareButton;
    public type: ShareableMoments;
    protected payload: string;

    protected constructor(type: ShareableMoments, payload?: string) {
        super();

        const gameSize = getGameSize();
        this.shareButton = new ShareButton(
            gameConfig.game_width * 0.45,
            gameConfig.game_height * 0.14
        );
        this.shareButton.x = gameSize.gameWidth / 2;
        this.shareButton.y = gameSize.gameHeight - this.shareButton.height;
        this.shareButton.alpha = 0;

        this.type = type;
        this.payload = payload;
        this.shareButton.once('trigger', this.handleShareButton.bind(this));
        if (sgPlatform !== Platform.Network) {
            this.addChild(this.shareButton);
        }
    }

    public tweenIn(): void {
        TweenMax.to(this.shareButton, 0.2, { alpha: 1 });
    }

    public tweenOut(...args: any): any {
        TweenMax.to(this.shareButton, 0.2, { alpha: 0 });
    }

    protected handleShareButton() {
        HudEmitter.instance.emit(HudActions.SHARE_MOMENT, this.type, this.payload);
    }
}
